import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, useIonModal, IonButtons, IonButton } from '@ionic/react';
import { useState, useEffect } from 'react';
import { addResourceListener } from '../firebase/resources';
import { addOutline, chevronBack } from 'ionicons/icons';
import { useHistory } from 'react-router';
import ResourceEditor from './ResourceEditor';

const Tab2: React.FC = () => {
  const history = useHistory();
  const [resources, setResources] = useState([]);
  const [resource, setResource] = useState({});

  useEffect(() => {
    addResourceListener((list: any) => {
      setResources(list);
    });
  }, []);

  const [presentEditor, dismissEditor] = useIonModal(ResourceEditor, {
    resource: resource,
    onDismiss: () => dismissEditor()
  });

  function openEditor(e: any = null) {
    if (e !== null) {
      setResource(e);
    } else {
      setResource({})
    }

    presentEditor();
  }

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Pokoje</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>


        {resources.map((r: any) => (
          <IonItem onClick={(e) => { openEditor(r) }} key={r.resourceId} >
            <IonLabel>{r.resourceTitle}</IonLabel>
          </IonItem>
        ))}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { openEditor() }}>
            <IonIcon icon={addOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default Tab2;
